import { onDomReady } from '../utils/dom';

function initializeOnePageNavs() {
    if (!document.body.classList.contains('onepager')) return;

    import('purejs_onepagenav').then(({ default: OnePageNav }) => {
        // https://github.com/M-Zoldak/PureJS_OnePageNav/wiki/Configuration
        new OnePageNav.default({
            navLinksSelector: '#left-nav a',
            defaultLinkActive: true,
            updateATagClass: true,
            // parentsObtainingActiveClass: ['li'],
            changeOffset: 33,
        });
    });
}

onDomReady(() => {
    initializeOnePageNavs();
});
